<main class="tw-mb-4 tw-font-inter tw-flex tw-flex-col tw-gap-4">

    <!-- HERO HEADER -->
    <header
      class="tw-relative tw-py-8 lg:tw-py-20 tw-bg-[url('assets/img/bread3.png')] tw-bg-cover tw-bg-center tw-filter tw-saturate-01">
  
      <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-rd-600/70 tw-via-rd-700/70 tw-to-rd-900/70"></div>
  
      <div class="tw-relative container tw-mx-auto tw-text-white">
        <h1 class="tw-text-4xl tw-font-bold tw-m-0">Consultancies</h1>
        <p class="tw-mt-2 tw-text-lg tw-mb-0">
          Explore consultancy services by eSupervisors
        </p>
      </div>
  
    </header>
  
  
    <!-- BREADCRUMB -->
    <nav aria-label="Breadcrumb">
      <div class="container">
        <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
      </div>
    </nav>
  
  
    <!-- SEARCH + FILTERS -->
    <section class="tw-mt-8">
  
      <div class="container tw-text-center tw-mb-8">
  
        <header>
          <h2 class="tw-text-gray-800 tw-text-2xl">
            Find Research Consultancy Services
          </h2>
  
          <p class="tw-text-gray-500 tw-font-normal tw-mb-6">
            Explore expert support for methodology, analysis, writing, and publication
          </p>
        </header>
  
        <!-- SEARCH -->
        <app-listings-searchbox [(ngModel)]="searchTerm" [searching]="isLoading" (search)="applyFilters()" (clear)="applyFilters()" placeholder="Search Consultancies..."></app-listings-searchbox>
      </div>
  
  
      <!-- RESULTS HEADER -->
      <div class="container tw-mb-4">
  
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-flex-wrap">
  
          <h3 class="tw-m-0 tw-flex tw-items-center tw-gap-1 tw-text-xl">
            Consultanc{{totalItems > 1 ? 'ies' : 'y'}}
  
            <span class="tw-text-sm tw-bg-rd-500 tw-text-white tw-p-1 tw-px-2 tw-rounded-md">
              {{ totalItems }}
            </span>
          </h3>
  
  
          <!-- SORT -->
          <div class="tw-flex tw-items-center tw-ms-auto">
  
            <app-button
              size="small"
              variant="ghost"
              [severity]="sortOrder === 'desc' ? 'primary' : 'secondary'"
              icon="fa-regular fa-arrow-down-short-wide"
              (click)="changeOrder('desc')" title="Descending Order">
            </app-button>
  
            <app-button
              size="small"
              variant="ghost"
              [severity]="sortOrder === 'asc' ? 'primary' : 'secondary'"
              icon="fa-regular fa-arrow-up-short-wide"
              (click)="changeOrder('asc')" title="Ascending Order">
            </app-button>
  
          </div>
  
  
          <!-- FILTERS -->
          <app-filters-dropdown>
  
            <div class="tw-flex tw-flex-col tw-gap-2">
  
              <label class="tw-font-semibold tw-text-gray-700 tw-text-sm">
                Price Range
              </label>
  
              <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
                <app-checkbox label="Session" [(ngModel)]="priceRange.single"/>
                <app-checkbox label="Project" [(ngModel)]="priceRange.project"/>
              </div>
  
              <div class="tw-flex tw-gap-2 tw-flex-wrapa tw-items-center">
  
                <div class="tw-flex tw-items-center tw-gap-1 tw-border-[1px] tw-border-gray-200 tw-border-solid tw-rounded-md tw-text-sm tw-text-gray-700">
                  <span class="tw-ml-2">₹</span>
                  <input
                    [(ngModel)]="priceRange.min"
                    class="tw-w-full tw-max-w-[3xl] tw-border-0 tw-p-2 tw-outline-none"
                    type="number"
                    inputmode="numeric"
                    min="0"
                    max="100000"/>
                </div>
  
                <div class="tw-flex tw-items-center tw-gap-1 tw-border-[1px] tw-border-gray-200 tw-border-solid tw-rounded-md tw-text-sm tw-text-gray-700">
                  <span class="tw-ml-2">₹</span>
                  <input
                    [(ngModel)]="priceRange.max"
                    class="tw-w-full tw-max-w-[3xl] tw-border-0 tw-p-2 tw-outline-none"
                    type="number"
                    inputmode="numeric"
                    min="0"
                    max="100000"/>
                </div>
  
              </div>
  
            </div>
  
            <div class="tw-flex tw-justify-end">
              <app-button label="Apply" size="small" (click)="applyFilters()"/>
            </div>
  
          </app-filters-dropdown>
  
        </div>
  
      </div>
  
    </section>
  
  
    <!-- CONSULTANCY LIST -->
    <section>
  
      <div class="container">
  
        <div class="row g-3">
  
          <!-- LOADING -->
          <ng-container *ngIf="isLoading">
  
            <div class="col-lg-4 col-md-6" *ngFor="let _ of [].constructor(12)">
              <app-content-loader mode="skeleton"></app-content-loader>
            </div>
  
          </ng-container>
  
  
          <!-- ERROR -->
          <ng-container *ngIf="error && !isLoading">
  
            <div class="col-12">
              <app-content-error (retry)="retryLoading()" [message]="error" />
            </div>
  
          </ng-container>
  
  
          <!-- RESULTS -->
          <ng-container *ngIf="!isLoading && !error && filteredConsultancies.length > 0">
  
            <article
              class="col-lg-4 col-md-6"
              *ngFor="let consultancy of filteredConsultancies; trackBy: trackByConsultancyId">
                <!-- <h4>{{consultancy?.title}}</h4> -->
              <app-consultancy-card
                [consultancy]="consultancy"
                (chat)="chatWithTeacher(consultancy)">
              </app-consultancy-card>
  
            </article>
  
          </ng-container>
  
  
          <!-- EMPTY STATE -->
          <ng-container *ngIf="shouldShowFallbackData()">
  
            <div class="col-12">
              <app-content-error
                type="not-found"
                heading="No Consultancies Results Found"
                [message]="searchTerm ? `We could not find any consultancies for your search: '${searchTerm}'` : 'We are unable to find any public consultancy services at the moment. Please try later'" />
            </div>
  
          </ng-container>
  
  
          <!-- PAGINATION -->
          <ng-container *ngIf="!isLoading && !error && filteredConsultancies.length > 0">
  
            <div class="col-12">
  
              <app-pagination
                [totalResults]="totalItems"
                [pageNum]="page"
                [limit]="limit"
                (pageChange)="onPageChange($event)">
              </app-pagination>
  
            </div>
  
          </ng-container>
  
        </div>
  
      </div>
  
    </section>
  
  </main>

<app-auth-modal [(visible)]="showLoginModal" (loginSuccess)="onLoginSuccess()"
    (closeModal)="closeLoginModal()"></app-auth-modal>